export const AUTOFILL_SELECTOR = ':-internal-autofill-selected';

export const isAutofillElement = (e: HTMLElement) => {
    try {
        return e.matches(AUTOFILL_SELECTOR);
    } catch {
        return false;
    }
};
